import {SxProps, Theme} from '@mui/material';
import theme from 'src/theme';

export const popoverSx: SxProps<Theme> = {
    '& .MuiPaper-root': {
        maxWidth: theme.spacing(200 / 8),
        width: '100%',
        p: 1,
    },
};
export const titleTextSx: SxProps<Theme> = {
    fontSize: theme.spacing(10 / 8),
    fontWeight: 500,
    color: theme.palette.neutral[400],
    textTransform: 'uppercase',
    my: 1,
};
export const nameRowSx: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    flexWrap: 'wrap',
    // Room for the menu button, which sits absolutely in the same corner the name would run into.
    pr: theme.spacing(32 / 8),
};
export const nameTextSx: SxProps<Theme> = {
    color: theme.palette.primary.main,
    fontSize: theme.spacing(14 / 8),
    fontWeight: 600,
};
/**
 * The name in the head, which opens the business.
 *
 * It keeps the head's own type rather than a link's: on the canvas the identity line is the darkest
 * thing on the card, and colouring it would make every card in the list read as a row of links.
 */
export const titleLinkSx: SxProps<Theme> = {
    color: 'inherit',
    fontSize: 'inherit',
    fontWeight: 'inherit',
};
/**
 * The same pill the column draws, so the business the sidebar points at is marked identically on a
 * phone and on a desktop.
 */
export const activePillSx: SxProps<Theme> = {
    px: 0.75,
    py: '1px',
    borderRadius: '6px',
    fontSize: '0.6875rem',
    fontWeight: 700,
    letterSpacing: '0.03em',
    textTransform: 'uppercase',
    color: theme.palette.success.main,
    backgroundColor: 'rgba(46, 125, 50, 0.12)',
    flexShrink: 0,
};
